import React, { useState } from 'react';
import { Icon } from '../../Icon';
import { parseBrazilianNumber } from '../../../utils/formatUtils';
import { FormField, ResultCard, EducationalBlock } from '../finance/shared';

const PercentageChangeCalculator = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [oldValue, setOldValue] = useState('100,00');
  const [newValue, setNewValue] = useState('120,00');
  const [resultState, setResultState] = useState<any>(null);

  const calculate = () => {
    const o = parseFloat(parseBrazilianNumber(oldValue)) || 0;
    const n = parseFloat(parseBrazilianNumber(newValue)) || 0;
    if (o === 0) return;

    const change = ((n - o) / o) * 100;
    const diff = n - o;

    const res = { change, diff };
    setResultState(res);
    onResultChange([
      { label: 'Valor Antigo', value: `R$ ${o.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` },
      { label: 'Valor Novo', value: `R$ ${n.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` },
      { label: 'Variação', value: `${change.toFixed(2)}%` }
    ]);
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-8 rounded-3xl shadow-lg border border-theme-border">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          <FormField label="Valor Antigo" value={oldValue} onChange={setOldValue} required isNumeric type="text" />
          <FormField label="Valor Novo" value={newValue} onChange={setNewValue} required isNumeric type="text" />
        </div>

        <div className="flex justify-center mb-8">
          <button
            onClick={calculate}
            className="px-12 py-4 bg-accent-gradient text-white rounded-xl font-bold hover:shadow-accent-hover hover:scale-[1.02] transition-all flex items-center justify-center gap-2"
          >
            <Icon name="play" className="w-5 h-5" />
            Calcular Variação
          </button>
        </div>

        {resultState && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <ResultCard title="Diferença Nominal" value={`R$ ${resultState.diff.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`} color="slate" />
            <ResultCard title="Variação Percentual" value={`${resultState.change.toFixed(2)}%`} color={resultState.change >= 0 ? 'emerald' : 'rose'} />
          </div>
        )}
      </div>

      <EducationalBlock
        title="Entendendo a Variação Percentual"
        tips={[
          'Variação Positiva: Indica um aumento (ex: inflação, lucro)',
          'Variação Negativa: Indica uma redução (ex: descontos, deflação)',
          'Fórmula: ((Valor Novo - Valor Antigo) / Valor Antigo) * 100',
          'Útil para comparar preços ao longo do tempo ou performance de investimentos'
        ]}
      />
    </div>
  );
};

export default PercentageChangeCalculator;
